






















import { Component, Vue, Prop } from 'vue-property-decorator';

@Component
export default class Modal extends Vue {
  private open: boolean = false;

  openModal() {
    console.log('OPEN MODAL');
    this.open = true;
  }
}
